import React from 'react';
import ReactMarkdown from 'react-markdown';

// Content and Markdown configuration are stable for completed messages while
// the composer or another message changes. Preserve their parsed output.
const MemoizedMarkdown = React.memo(ReactMarkdown);

export default MemoizedMarkdown;
